module.exports = __webpack_public_path__ + "assets/img/icon3.1.68ee1d1f.svg";